import * as ww from '@wecom/jssdk'
import { getJsapiTicket, getAgentJsapiTicket } from '@/api/auth'

const agentSignatureCache = new Map()

const resolveCurrentUrl = () => window.location.href.split('#')[0]

const normalizeSignature = (signatureData = {}) => ({
  timestamp: signatureData.timestamp,
  nonceStr: signatureData.nonceStr || signatureData.noncestr,
  signature: signatureData.signature
})

const resolveRegisterConfig = (signatureData = {}) => {
  const corpId = signatureData.corpId || signatureData.corpid || signatureData.appId || signatureData.appid
  const agentId = signatureData.agentId || signatureData.agentid

  if (!corpId || !agentId) {
    throw new Error('getAgentJsapiTicket 返回缺少 corpId 或 agentId')
  }

  return {
    corpId,
    agentId: Number(agentId)
  }
}

const getAgentSignatureData = async (url) => {
  if (agentSignatureCache.has(url)) {
    return agentSignatureCache.get(url)
  }

  const signatureData = await getAgentJsapiTicket({ url })
  const cachedSignatureData = {
    ...signatureData,
    url
  }

  agentSignatureCache.set(url, cachedSignatureData)
  return cachedSignatureData
}

export const registerWecomApp = async ({ jsApiList = [], url = resolveCurrentUrl() } = {}) => {
  const getConfigSignature = async (signatureUrl) => {
    const signatureData = await getJsapiTicket({ url: signatureUrl })
    return normalizeSignature(signatureData)
  }

  const getAgentConfigSignature = async (signatureUrl) => {
    const signatureData = await getAgentSignatureData(signatureUrl)
    return normalizeSignature(signatureData)
  }

  const agentSignatureData = await getAgentSignatureData(url)
  const registerConfig = resolveRegisterConfig(agentSignatureData)

  await ww.register({
    corpId: registerConfig.corpId,
    agentId: registerConfig.agentId,
    jsApiList,
    getConfigSignature,
    getAgentConfigSignature
  })

  return {
    ww,
    corpId: registerConfig.corpId,
    agentId: registerConfig.agentId
  }
}

export const getWecomContextInfo = async () => {
  const contextResult = await ww.getContext()
  const entry = contextResult?.entry

  if (entry === 'single_chat_tools') {
    const contactResult = await ww.getCurExternalContact()
    return {
      entry,
      type: 'single_chat_tools',
      result: contactResult
    }
  }

  if (entry === 'group_chat_tools') {
    const chatResult = await ww.getCurExternalChat()
    return {
      entry,
      type: 'group_chat_tools',
      result: chatResult
    }
  }

  return {
    entry,
    type: 'other',
    result: null
  }
}
